import React from 'react';
import { Stack } from '@mui/material';
import { LegalItem, LegalPage, LegalSection, LegalText } from '@src/components/LegalPage';

const Privacy: React.FC = () => (
    <LegalPage
        title="Aviso de Privacidad"
        intro="Qué datos tuyos guardamos, para qué los usamos y cómo puedes pedirnos que los eliminemos."
        updated={new Date().toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' })}
    >
        <LegalSection title="Responsable">
            <LegalText>
                Kabandú Orígenes S.A. de C.V., con domicilio en Mexicali, Baja California, México, es responsable del
                uso de tus datos personales.
            </LegalText>
        </LegalSection>

        <LegalSection title="Finalidad del uso">
            <LegalText>
                Los datos que nos proporcionas (nombre, teléfono, correo, fecha de nacimiento y datos fiscales) se usan
                para:
            </LegalText>
            <Stack spacing={1.5} sx={{ pt: 0.5 }}>
                <LegalItem>Emisión y envío de recibos por medios electrónicos (WhatsApp y correo).</LegalItem>
                <LegalItem>Registro y operación de tu cuenta en el programa de Pesos Kabandú.</LegalItem>
                <LegalItem>Avisos sobre tus citas y los servicios que recibes.</LegalItem>
                <LegalItem>Mejorar tu experiencia como clienta.</LegalItem>
            </Stack>
        </LegalSection>

        <LegalSection title="Medidas de seguridad">
            <LegalText>
                Kabandú implementa medidas técnicas y administrativas para proteger tus datos personales y evitar su
                pérdida, uso indebido, acceso no autorizado o divulgación.
            </LegalText>
        </LegalSection>

        <LegalSection title="Derechos ARCO">
            <LegalText>
                Puedes ejercer en cualquier momento tus derechos de Acceso, Rectificación, Cancelación u Oposición
                (ARCO) escribiendo a supago@kabandu.com. En la página «Eliminar mis datos» está el detalle del proceso.
            </LegalText>
        </LegalSection>

        <LegalSection title="Conservación de datos">
            <LegalText>
                Tus datos se conservan por el tiempo necesario para cumplir con las obligaciones fiscales y legales
                correspondientes (5 años, según la ley fiscal mexicana).
            </LegalText>
        </LegalSection>

        <LegalSection title="Modificaciones">
            <LegalText>
                Este aviso puede modificarse en cualquier momento. Cualquier cambio se notificará por nuestros canales
                oficiales: la app, el correo electrónico o nuestros establecimientos.
            </LegalText>
        </LegalSection>
    </LegalPage>
);

export default Privacy;
